<div class="h5peditor-loading h5p-throbber">
  <img class="h5peditor-elearnio-logo" src="/assets/images/elearnio-logo-retina.png" alt="spinner">
  <div class="linear-spinner">
    <img class="spinner" src="/assets/images/spinner-v1.gif" alt="spinner">
  </div>
</div>
